import { render, staticRenderFns } from "./DuplicatePatientModal.vue?vue&type=template&id=5da9b3a6&scoped=true&"
import script from "./DuplicatePatientModal.vue?vue&type=script&lang=js&"
export * from "./DuplicatePatientModal.vue?vue&type=script&lang=js&"
import style0 from "./DuplicatePatientModal.vue?vue&type=style&index=0&id=5da9b3a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da9b3a6",
  null
  
)

export default component.exports